import { Injectable } from '@angular/core';
import { FileDescriptor, FoldersResponse, FoldersResponseInner } from 'src/app/swagger-api';
import { CustomFileSystemItem } from '../filemanager-interfaces/filemanager.interface';

@Injectable()
export class FileManagerAdapter {
  public foldersResponseAdapter(
    foldersResponse: FoldersResponse,
    onlyYouTexting = 'Only you',
    membersTexting = 'members',
  ): CustomFileSystemItem[] {
    return foldersResponse.map((item: FoldersResponseInner) => {
      return {
        name: item.entity['name'],
        isDirectory: item.entity_kind === 'folder_descriptor',
        size: item.entity_kind === 'folder_descriptor' ? 0 : (item.entity as FileDescriptor).size,
        dataItem: {
          item,
          members: item.security.length > 1 ? `${item.security.length} ${membersTexting}` : onlyYouTexting,
        },
        dateModified: new Date(item.entity['modified']),
        hasSubDirectories: false,
        path: '',
        pathKeys: undefined,
        thumbnail: '',
        getFileExtension(): string {
          return '';
        },
        key: item.entity['entity_id'],
      };
    });
  }
}
